// extracted by mini-css-extract-plugin
export default {"tag":"TagComponent_tag__Q7wy6"};